import { Link } from 'react-router-dom';
import type { NewsItem } from '@/types/content';
import NewsListItem from '@/components/feature/NewsListItem';

export default function LatestNews({ items }: { items: NewsItem[] }) {
  return (
    <section>
      <div className="mb-5 flex items-end justify-between border-b border-background-200 pb-3">
        <div className="flex items-center gap-2">
          <span className="flex h-7 w-1.5 rounded-full bg-primary-500" />
          <h2 className="font-heading text-xl font-black text-foreground-950 md:text-2xl">最新动态</h2>
          <span className="hidden text-xs text-foreground-500 sm:block">按时效追踪，第一时间掌握娱乐要闻</span>
        </div>
        <Link
          to="/news"
          className="flex items-center gap-1 whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
        >
          查看全部
          <i className="ri-arrow-right-s-line" />
        </Link>
      </div>
      <div className="flex flex-col gap-3 md:gap-4">
        {items.map((item) => (
          <NewsListItem key={item.id} item={item} />
        ))}
      </div>
    </section>
  );
}